import { localRoutes } from "../../../config";
import { AuthStatus, BetaStatus, RegistrationStatus } from "../../../types";
import { PageSpinner } from "../../components/Spinner";
import { LocalNavigate } from "../../hooks/localNavigation";
import { useUser } from "../../hooks/useUser";

export const RedirectIfAuthed = ({ children }: { children: JSX.Element }) => {
  const { userAuthStatus, userCompletedRegistration, betaStatus, isBeta } = useUser();

  if (
    userAuthStatus === AuthStatus.LOADING ||
    userCompletedRegistration === RegistrationStatus.LOADING ||
    betaStatus === BetaStatus.LOADING
  ) {
    return <PageSpinner />;
  }

  if (userAuthStatus === AuthStatus.AUTHENTICATED && userCompletedRegistration !== RegistrationStatus.FINISH) {
    return <LocalNavigate to={localRoutes.accountSetupSpecify} replace />;
  }

  if (isBeta) {
    if (betaStatus === BetaStatus.NOT_FINISH) {
      return <LocalNavigate to={localRoutes.betaFlow.steps.base} replace />;
    }

    if (betaStatus === BetaStatus.FINISH) {
      return <LocalNavigate to={localRoutes.betaFlow.success} replace />;
    }

    return <LocalNavigate to={localRoutes.betaFlow.welcome} replace />;
  }

  if (userAuthStatus === AuthStatus.AUTHENTICATED && userCompletedRegistration === RegistrationStatus.FINISH) {
    return <LocalNavigate to={localRoutes.getChannel} replace />;
  }

  return children;
};
